import "./App.css";
import {
  Routes,
  Route,
  BrowserRouter as Router,
  Navigate,
} from "react-router-dom";
import Login from "./authScreen/Login";
import Home from "./Home";
import HomeIndex from "./screen/home";
import Dashboard from "./screen/Dashboard";
import Notification from "./screen/Notification";
import Grants from "./screen/Grants";
import MyApplication from "./screen/MyApplication";
import MyProfile from "./screen/MyProfile";
import Settings from "./screen/Settings";
import { SnackbarProvider } from "notistack";
import Signup from "./authScreen/Signup";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Register from "./screen/Register";
import Invoice from "./screen/Invoice";
import ForgotPassword from "./authScreen/ForgotPassword";
import ResetPassword from "./authScreen/ResetPassword";
import ValidateOtp from "./authScreen/Otp";
import ApplicationDetails from "./screen/ApplicationDetails";
import TermsAndConditions from "./screen/TermsAndCondition";


function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        cacheTime: Infinity,
      },
    },
  });
  
  return (
    <div className="">
      <SnackbarProvider
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      />
      <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route element={<Home />}>
            <Route path="/" element={<HomeIndex />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/notification" element={<Notification />} />
            <Route path="/grants" element={<Grants />} />
            <Route path="/myapplication" element={<MyApplication />} />
            <Route path="/myprofile" element={<MyProfile />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/register" element={<Register />} />
            <Route path="/invoice" element={<Invoice />} />
            <Route path="/application/application-details" element={<ApplicationDetails />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/otp" element={<ValidateOtp />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/terms-and-condition" element={<TermsAndConditions />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
        </Routes>
      </Router>
      </QueryClientProvider>
    </div>
  );
}

export default App;
